import { VALIDATION_TEMPLATE } from './validationTemplete';

export const UNIT_PRICE_VALIDATION = {
  FIELDS: [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ],
  MESSAGE: {
    january: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    february: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    march: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    april: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    may: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    june: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    july: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    august: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    september: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    october: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    november: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
    december: {
      pattern: VALIDATION_TEMPLATE.pattern('個別単価'),
    },
  },
  RULES: {
    january: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    february: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    march: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    april: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    may: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    june: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    july: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    august: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    september: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    october: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    november: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
    december: {
      pattern: /^\d+(\.\d{1,2})?$/,
      nullable: true,
    },
  },
};
